import type { FaireThemeEntity } from "../../entity_types/theme";

export const small_treasures_and_youthful_joy: FaireThemeEntity = {
  token: "small-treasures-and-youthful-joy",
  type: "theme",
  name: "Small Treasures & Youthful Joy",
  description: "Charming kids' accessories and personalized youth pieces -- perfect impulse buys or seasonal gift basket fillers.",
  teaser: "Impulse-buy kids' treasures for Easter baskets and gift sets.",
  detail: "Your strong history of kids' crossbody bags, babygowns, and sequined accessories shows demand for unique children's items. Built around your searches for Easter egg stuffers and custom shirt youth.",
  bgColor: "#F5F0D4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_fehh7weeze",
    "p_nc4f5tgnhy",
    "p_dja88ypjme",
    "p_sgc68y9g72",
    "p_b7mcw4zp8w",
    "p_6yjlq7vx7c",
    "p_7nxa837bc5",
    "p_kr7qbmp4qa",
    "p_be84b94p4k",
    "p_7j4zkbp3zt",
    "p_mcnd7wg8ef",
    "p_cjyosafbex",
    "p_buwyasv924",
    "p_erbcktg8dq",
    "p_dpsik4qn2q",
    "p_35faeewhz8",
    "p_e58ut43pcr",
    "p_c5dm7n9wjr",
    "p_szr2yjjm3w",
    "p_r7hm4ba4r7",
    "p_7wri7evhpd",
    "p_495tk8rjga",
    "p_dfbdcrzs34",
    "p_7krhb2yvpp",
    "p_pu9f7w7pak",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
